jQuery(function($) {
  $j('.nj_blogsidebar_control span, .njohn_blogsidebar_label a[nj="full-screen"], .cd-vertical-nav li:nth-of-type(1)').click(function(){
	if($j(this).attr('nj-check') == 'ok')
    {
		$j('.nj_blogsidebar_control span, .cd-vertical-nav li:nth-of-type(1)').attr('nj-check','');
		$j('.nj_blog_container').removeClass('nj_blogmain_toggle');
        $j('.nj_blogsidebar > div:not(:first-child)').css('display','block');
		$j('.nj_blogsidebar').css({width: '20%'});
		$j('.nj_blogsidebar_control').css({"border-bottom": '1px solid #dddddd'});
		$j('.nj_blogsidebar_control span, .cd-vertical-nav li:nth-of-type(1) span').html('Full Page View');
		$j('.nj_blogsidebar_control span').attr('title','Full Page View');
		$j('.nj_blogsidebar_control span').removeClass('material-icons');
		$j('.nj_blogsidebar_control span').addClass('nj_full_view');
	}
	else
    {
		$j('.nj_blogsidebar_control span, .cd-vertical-nav li:nth-of-type(1)').attr('nj-check','ok');
		$j('.nj_blog_container').addClass('nj_blogmain_toggle');
		$j('.nj_blogsidebar > div:not(:first-child)').css('display','none');
		$j('.nj_blogsidebar').css({width: '50px'});
		$j('.nj_blogsidebar_control').css({"border-bottom": '0'});
		$j('.nj_blogsidebar_control span').html('reorder');
		$j('.cd-vertical-nav li:nth-of-type(1) span').html('Show Menu');
		$j('.nj_blogsidebar_control span').attr('title','Show Menu');
		$j('.nj_blogsidebar_control span').addClass('material-icons');
		$j('.nj_blogsidebar_control span').removeClass('nj_full_view');
	}
  });

	$j('.njohn_block-underline div[nj-search-tags] input').keyup(function () {
		var rex = new RegExp($j(this).val(), 'i');
		$j('.njohn_block-underline ul[nj-tag-list] li').hide();
		$j('.njohn_block-underline ul[nj-tag-list] li').filter(function () {
			return rex.test($j(this).text());
		}).show();
	})

});



